import { trackError } from '@proposify/frontend-observability';

const VIEWING_SESSION_KEY = 'viewingSessionId';

export function getOrCreateViewingSessionId(): string {
  try {
    const stored = sessionStorage.getItem(VIEWING_SESSION_KEY);
    if (stored) {
      const parsed: unknown = JSON.parse(stored);
      if (typeof parsed === 'string' && parsed.trim().length > 0) {
        return parsed;
      }
    }
    const newId = crypto.randomUUID();
    sessionStorage.setItem(VIEWING_SESSION_KEY, JSON.stringify(newId));
    return newId;
  } catch {
    // A corrupted stored value (JSON.parse threw) lands here with sessionStorage itself still
    // writable — persist the fallback id so every caller in this tab (useFeatureFlagAnonymous,
    // useTrackViewing) converges on the same session id instead of each generating its own.
    const fallbackId = crypto.randomUUID();
    try {
      sessionStorage.setItem(VIEWING_SESSION_KEY, JSON.stringify(fallbackId));
    } catch (storageError) {
      // sessionStorage itself unavailable (e.g. disabled) — nothing to persist; the caller still
      // gets a usable id for this call, but this is worth surfacing rather than swallowing.
      trackError(storageError, { errorFrom: 'editor-remote', feature: 'anonymous-session' });
    }
    return fallbackId;
  }
}
